import { getScopedKey } from '../utils/userScopedStorage';

const STORAGE_KEY = 'ats_favorite_pages';
const MAX_FAVORITES = 12;

function readFavorites() {
  try {
    return JSON.parse(localStorage.getItem(getScopedKey(STORAGE_KEY)) || '[]');
  } catch {
    return [];
  }
}

// RC18.7 Phase 2 — user-pinned pages, mirroring useRecentPages.js's localStorage pattern.
// Surfaced in Layout.js's drawer (a "Favorites" section above the grouped nav) and toggled
// from the AppBar star button next to the page's resolved label.
export function getFavoritePages() {
  return readFavorites();
}

export function isFavoritePage(path) {
  return readFavorites().some((f) => f.path === path);
}

// Returns the new favorited state (true = now a favorite) so the caller can update its own UI.
export function toggleFavoritePage(path, label) {
  const favorites = readFavorites();
  const existingIndex = favorites.findIndex((f) => f.path === path);
  if (existingIndex >= 0) {
    favorites.splice(existingIndex, 1);
    localStorage.setItem(getScopedKey(STORAGE_KEY), JSON.stringify(favorites));
    return false;
  }
  favorites.unshift({ path, label });
  localStorage.setItem(getScopedKey(STORAGE_KEY), JSON.stringify(favorites.slice(0, MAX_FAVORITES)));
  return true;
}

export default getFavoritePages;
